module.exports = __webpack_public_path__ + "static/media/icon-message-counter.a881437b.svg";